import * as React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { BeatLoader } from 'react-spinners';
import { Location } from 'history';
import { IAuthState, UserTypes } from '../store/types';
import routes from '../../Routing/routes';
import { WrappedInput } from '../../../share/components/Input/Input';

export interface ILoginState {
  email: string;
  password: string;
  errorMessage: string;
  loading: boolean;
}

export interface ILoginProps {
  auth: IAuthState;
  onLogin: (username: string, password: string) => any;
  history: any;
  location: Location<any>;
}

export class Login extends React.Component<ILoginProps, ILoginState> {
  constructor(props: ILoginProps) {
    super(props);
    this.state = {
      email: '',
      errorMessage: '',
      password: '',
      loading: false,
    };
  }
  public componentDidMount(): void {
    this.checkAuth(this.props.auth.userType)
  }
  public componentWillReceiveProps(nextProps: ILoginProps): void {
    const { loading, errorMessage } = nextProps.auth;
    this.setState({
      ...this.state,
      loading,
      errorMessage
    });
    this.checkAuth(nextProps.auth.userType)
  }
  public checkAuth(userType): void {
    if (userType !== UserTypes.UNAUTH) {
      const state = this.props.location.state
      const to = state && state.from || routes.HOME;
      this.props.history.replace(to);
    }
  }

  public setValue = (property: 'email' | 'password') => (event): void => {
    this.setState({
      ...this.state,
      [property]: event.target.value,
    });
  }

  public login = (): void => {
    const { email, password } = this.state;
    this.props.onLogin(email.toLowerCase(), password);
  }
  public forgotPassword = (): void => {
    this.props.history.push('/forgotpassword')
  }
  public handleKeyPress = (event): void => {
    if (event.key === 'Enter') {
      this.login();
    }
  }
  public render(): React.ReactElement {
    const {
      errorMessage,
      loading,
      email, password
    } = this.state;
    return (
      <>
        <Row>
          <WrappedInput required={true} value={email} onChange={this.setValue("email")} placeholder={"Enter email"} md="12" type="text" className="login-email-input" />
        </Row>
        <Row>
          <div className="forgotContainer">
            <WrappedInput required={true} value={password} onChange={this.setValue("password")} className="login-password-input"
              onKeyPress={this.handleKeyPress} placeholder={"Enter password"} md="12" type="password" />
          </div>
        </Row>
        <Row>
          <Col md={7} />
          <Col md={5}>
            <Button block={true} disabled={loading} onClick={this.login}>
              Login
            </Button>
            <p className="forgot" onClick={this.forgotPassword}>Forgot password?</p>
          </Col>
        </Row>
        {loading ?
          <BeatLoader loading={loading} /> :
          <div className="FormError">
            {errorMessage}
          </div>}
      </>
    );
  }
}

export default Login; 



// WEBPACK FOOTER //
// ./src/modules/Auth/Login/Login.tsx